const emojis = [
  [":)", "😀"],
  [";)", "😉"],
  [":(", "🙁"],
  [":-)", "😀"],
  [";-)", "😉"],
  [":-(", "🙁"],
  [":+1:", "👍"],
  [":-1:", "👎"],
  [":cool:", "😎"],
  [":heart:", "❤️"],
  [":fire:", "🔥"],
  [":shit:", "💩"],
  [":party:", "🎉"],
  [":100:", "💯"],
  [":ren:", "🦌"],
  [":rentouch:", "🦌"],
  [":ahirsch:", "🦌"],
  [":pizza:", "🍕"],
  [":coffee:", "☕"],
  ["->", "→"],
  ["=>", "⇒"],
  ["<-", "←"],
  ["<=", "⇐"],
];

interface Replacement {
  text: string;
  updatePos: (pos: number) => number;
}

export function replaceEmoji(text: string): Replacement | undefined {
  const emoji = emojis.find((em) => text.includes(em[0]));
  if (emoji) {
    const start = text.indexOf(emoji[0]);
    if (start >= 0) {
      return {
        text: text.substring(0, start) + emoji[1] + text.substring(start + emoji[0].length),
        updatePos(pos: number) {
          return pos > start && pos < start + emoji[0].length //avoid placing the cursor inside the emoji
            ? start + emoji[1].length
            : pos - emoji[0].length + emoji[1].length;
        },
      };
    }
  }
}
